import React, { useLayoutEffect } from "react";
import Navbar from "./navbar";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "./footer";
import { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const Layout = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);
  return (
    <>
      <SkeletonTheme baseColor="#f0f0f5" highlightColor="#dbdbe0">
        <Navbar />
        <main>
          <Outlet />
        </main>
        <Footer />
      </SkeletonTheme>
    </>
  );
};

export default Layout;
